const VERSION = '2.0.14b'
export default VERSION
